export default __webpack_public_path__ + "static/05_V1@2x-facb03150ea4da18613ed0e31990ea3e.png";